import React from "react";

function NotFound() {
  return (
    <div>
      <h1>Note Found</h1>
      <p className="lead">The page you are looking for does not exist...</p>
    </div>
  );
}

export default NotFound;
